import { getApi } from "./httpsClient";

/**
 * Executive Summary dashboard data.
 * รวมทุก section ใน call เดียว (เก็บไว้เป็น fallback) — ปกติ FE ยิงแยกตาม section ด้านล่าง
 * GET /dashboard/executive-summary?year=&month=&day=&start_date=&end_date=&warehouse_id=
 */
export const getExecutiveSummary = (accessToken, params) =>
  getApi("dashboard/executive-summary", accessToken, params);

// ── Section endpoints (ยิงขนาน + render อิสระ) — query param ชุดเดียวกันทั้งหมด ──

/** KPI cards (เบาสุด) */
export const getDashboardKpis = (accessToken, params) =>
  getApi("dashboard/kpis", accessToken, params);

/** Outstanding + SEA/LAND freight */
export const getDashboardMetrics = (accessToken, params) =>
  getApi("dashboard/metrics", accessToken, params);

/** Shipment status + trend + company top */
export const getDashboardOperations = (accessToken, params) =>
  getApi("dashboard/operations", accessToken, params);

/** Inbound + Package Type summary (หนักสุด) — section เดียวที่ส่ง `month` (คอลัมน์ Month) + `day` (คอลัมน์แรก) */
export const getDashboardSummaries = (accessToken, params) =>
  getApi("dashboard/summaries", accessToken, params);

/**
 * Inbound Summary แบบเต็มของวันที่เลือก — drill-down จากหัวคอลัมน์ Company (หน้า DashboardInboundSummaryCompany)
 * ใช้ condition ชุดเดียวกับ summaries (year/month/day) คืน period เดียวแต่ครบทุกบริษัทที่มีของเข้า
 */
export const getDashboardInboundCompanies = (accessToken, params) =>
  getApi("dashboard/summaries/inbound-companies", accessToken, params);

/**
 * ลูกค้าของบริษัทเดียวที่มีของเข้าในวันที่เลือก — drill-down ต่อจากการกดชื่อบริษัท
 * (หน้า DashboardInboundCompanyDetail) · ต้องส่ง `company_code` มาด้วย
 */
export const getDashboardInboundCustomers = (accessToken, params) =>
  getApi("dashboard/summaries/inbound-customers", accessToken, params);
